import type { PdfComponent } from '../../TermsAndConditionsRender/components/typed';

export const SECTION10: PdfComponent = {
  type: 'section',
  id: 's10',
  title: '10. Anti-Bribery',
  content: [
    {
      type: 'bulletList',
      id: 's10bullets',
      bulletType: 'number',
      content: [
        {
          copy: 'For the purposes of this clause 10, the expressions “adequate procedures” and “associated with” shall be construed in accordance with the Bribery Act 2010 and any relevant legislation or guidance published under it.',
        },
        {
          copy: 'The Subscriber shall ensure that it and each person referred to in clauses 10.2(a) to 10.2(c) (inclusive) does not, by any act or omission, place Kanda in breach of any Bribery Laws. The Subscriber shall comply with all applicable Bribery Laws, including ensuring that it has in place adequate procedures to prevent bribery and ensuring that:',
          sublist: {
            bulletType: 'alpha',
            content: [
              {
                copy: "all of the Subscriber's personnel and all direct and indirect sub-contractors, suppliers, agents and other intermediaries;",
              },
              {
                copy: 'all others associated with the Subscriber; and',
              },
              {
                copy: 'each person employed by or acting for or on behalf of any of those persons referred to in clauses 10.2(a) and/or 10.2(b);',
              },
            ],
          },
        },
        {
          copy: 'Without limitation to clause 10.2, the Subscriber shall not make or receive any bribe (which term shall be construed in accordance with the Bribery Act 2010) or other improper payment or advantage, or allow any such bribe or improper payment or advantage to be made or received on its behalf, whether in the United Kingdom or elsewhere. The Subscriber shall implement and maintain adequate procedures to ensure that such bribes or improper payments or advantages are not made or received directly or indirectly on its behalf.',
        },
        {
          copy: 'The Subscriber shall immediately notify Kanda as soon as it becomes aware of a breach or possible breach of any of the requirements in this clause 10.',
        },
        {
          copy: 'Any breach of clause 10 by the Subscriber shall be deemed a Material Breach of this Agreement that is not remediable and shall entitle Kanda to immediately terminate this Agreement by notice under clause 14.3(a).',
        },
      ],
      prefix: '10',
    },
  ],
};
